import React from "react";
import Filter from '../../../components/CRM/Filter';
import ReferenceInput from "../../../components/CRM/ReferenceInput";
import TextInput from "../../../components/CRM/TextInput";
import AutocompleteInput from "../../../components/CRM/AutocompleteInput";
import AutoComplete from "material-ui/AutoComplete";
import DateInput from "../../../components/CRM/DateInput";

const StoreMessageFilter = props => (
  <Filter {...props}>
    <ReferenceInput
      label="resources.storeMessages.fields.storeName"
      source="kiosk_id"
      reference="kiosks"
      sort={{field: "name", order: "ASC"}}
      allowEmpty={false}
    >
      <AutocompleteInput
        optionText="name"
        options={{filter: AutoComplete.caseInsensitiveFilter}}
        isFilter={true}
      />
    </ReferenceInput>

    <TextInput
      label="resources.storeMessages.fields.smsFrom"
      source="sms_from_like"
    />
    <TextInput
      label="resources.storeMessages.fields.emailFrom"
      source="email_from_like"
    />
    <TextInput
      label="resources.storeMessages.fields.emailSubject"
      source="email_subject_like"
    />

    <DateInput label="resources.storeMessages.fields.sentAt" source="sent_at_on_date" />
  </Filter>
);

export default StoreMessageFilter;



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/StoreMessageFilter.js